import Vue from "vue"
import config from '../../config'
import util from './util';

export default {
    sendNotificationByTopic(topic, body, params = {}) {
        return Vue.http.post(config.apiBaseUrl + '/zepplin/push-notification/topic/' + topic, body, util.makeRequestConfig(params)).then((response) => response.json())
    }
}